// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.comment-todo{
    border-radius: 13px;
    border: 2px solid #ebebeb;
    overflow: hidden;
}
.post-views{
    font-size: 12px;
    color: #818181;
}
.post-icons{
    height: 40px;
    width: 40px;
    margin: auto
}
.post-icons:hover{
    border: 2px solid darkgray;
    border-radius: 50%;
    transform: scale(0.9);
    transition: transform .1s ease-in-out;
    cursor: pointer
}
.comment-name{
    color: #050505;
    font-size: 10px;
}
.comments-border{
    border: 1px solid #c3c3c3;
    padding: 10px 5px;
    border-radius: 10px;
    background-color: #f2f2f2;

}
.comments-img{
    width: 43px;
    border-radius: 100%;
    border: 2px solid #000;
}
.taskdone{
    font-size: 10px;
     color: #818181;;
}
.fs-btn-accept{
    font-size: 20px;
    background-color: #009345!important;
    border: 1px solid #ccc;
    font-weight: 700;
}
.star-gold{
    color: #fa921b;
    font-size: 12px;
   
}
.icon-green{
    color: #3ab34a;
    font-size: 15px;
}
.text-comment{
 
    position: relative;
    left: 162px;
}
.comment-text {
    background-color: var(--bs-blue);
    width: 240px;
    color: #f2f2f2;
    position: relative;
    word-wrap: break-word; /* Break long words to prevent overflow */
    overflow-wrap: break-word; /* Ensures text breaks to next line */
    white-space: pre-wrap; /* Preserves whitespace and wraps text */
    overflow: hidden; /* Hides any overflowing content */
}
.comment-text::before{
    display: block;
    clear: both;
    content: "";
    position: absolute;
    bottom: -8px;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 12px;
    transform: rotate(317deg);
    border-color: #3e353500 #9b969600 #f8f9fa00 var(--bs-blue);
    right: -12px;
}
.comment-textRight{
    background-color:  var(--bs-tertiary-bg);
    width: 240px;
    color: black;
    overflow-wrap: break-word;
}
.todo-border{
    border: 2px solid black;
    border-radius: 0.25em;
   font-size: small;
}
.todo-border:checked {
    background-color: #009345;
    border-color: #009345;
}
.todo-label{
    color: #818181;
}
.video-post{
    border-radius: 10px;
}
/* .comment-text-bottom{
    position: absolute;
    height: 0;
    border-style: solid;
    border-width: 12px;
    border-color: #3e353500 #9b969600 #f8f9fa00 var(--bs-blue);
    right: -12px;
} */
.codecolor{
    background-color: #818181;
    display: inline-block;
    width: 30px;
    height: 30px;
    border-radius: 100%;
    text-align: center;
    line-height: 27px;
    color: #fff;
    margin-top: 4px;
}
.moving-aud{
    position: relative;
 
}
.moving-aud audio{
    width: 220px!important;
}
.custom-form-edit{
    width: 170px;
    padding: 10px;
    margin: 5px;
    box-sizing: border-box;
    border: 1px solid #ccc;
}
.comment-text.comment1-text::before {
    display: none;
   }
   .scrollableChat {
    overflow-y: auto;
    height: calc(65vh - 100px);
}
.comment-text1{
    width: 240px;
    /* color: #f2f2f2; */
    position: relative;
}
.comment-textRight1{
    width: 240px;
    /* color: black; */
    overflow-wrap: break-word;
}
.text-dark i{
    font-weight: 900;
}
.scrollable-overflow{
    overflow-x: hidden;
}
.absoluteposition{
    position: absolute;
    right: 150px;
    bottom: -15px;
}

/* Modal overlay */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
  }
  
  /* Modal content */
  .modal-comments .modal-content{
    position: relative;
    background: white;
    padding: 20px;
    width: 500px;
    height: auto;
    border-radius: 10px;
    text-align: center;
  }
  
  .close-button {
    position: absolute;
    top: 10px;
    right: 10px;
    background: transparent;
    border: none;
    font-size: 24px;
    cursor: pointer;
  }
  
  /* Enlarged image */
  .enlarged-image {
    max-width: -moz-fit-content;
    max-width: fit-content;
    display: flex;
    align-items: center;
    justify-content: center;
    max-height: 80vh;
  }
  
@media screen and (max-width:576px) {
    .imagewidth-comments{
        width: 100%;
    }
    .enlarged-image {
        max-width: 89%;
      }
      .en-large{
        display: flex;
        justify-content: center;
      }
    .todos-home{
        padding-left: 3px;
    }
   .gigclass{
      padding-left: 5px;
   }
}`, "",{"version":3,"sources":["webpack://./src/Components/comments/Comments.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,cAAc;AAClB;AACA;IACI,YAAY;IACZ,WAAW;IACX;AACJ;AACA;IACI,0BAA0B;IAC1B,kBAAkB;IAClB,qBAAqB;IACrB,qCAAqC;IACrC;AACJ;AACA;IACI,cAAc;IACd,eAAe;AACnB;AACA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;;AAE7B;AACA;IACI,WAAW;IACX,mBAAmB;IACnB,sBAAsB;AAC1B;AACA;IACI,eAAe;KACd,cAAc;AACnB;AACA;IACI,eAAe;IACf,mCAAmC;IACnC,sBAAsB;IACtB,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,eAAe;;AAEnB;AACA;IACI,cAAc;IACd,eAAe;AACnB;AACA;;IAEI,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,gCAAgC;IAChC,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,qBAAqB,EAAE,yCAAyC;IAChE,yBAAyB,EAAE,qCAAqC;IAChE,qBAAqB,EAAE,wCAAwC;IAC/D,gBAAgB,EAAE,kCAAkC;AACxD;AACA;IACI,cAAc;IACd,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,QAAQ;IACR,SAAS;IACT,mBAAmB;IACnB,kBAAkB;IAGlB,yBAAyB;IACzB,0DAA0D;IAC1D,YAAY;AAChB;AACA;IACI,wCAAwC;IACxC,YAAY;IACZ,YAAY;IACZ,yBAAyB;AAC7B;AACA;IACI,uBAAuB;IACvB,qBAAqB;GACtB,gBAAgB;AACnB;AACA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;AACA;IACI,cAAc;AAClB;AACA;IACI,mBAAmB;AACvB;AACA;;;;;;;GAOG;AACH;IACI,yBAAyB;IACzB,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;IACX,eAAe;AACnB;AACA;IACI,kBAAkB;;AAEtB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,YAAY;IACZ,aAAa;IACb,WAAW;IACX,sBAAsB;IACtB,sBAAsB;AAC1B;AACA;IACI,aAAa;GACd;GACA;IACC,gBAAgB;IAChB,0BAA0B;AAC9B;AACA;IACI,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;AAC7B;AACA;IACI,gBAAgB;AACpB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;AACjB;;AAEA,kBAAkB;AAClB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;EACf;;EAEA,kBAAkB;EAClB;IACE,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,eAAe;EACjB;;EAEA,mBAAmB;EACnB;IACE,2BAAsB;IAAtB,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;EAClB;;AAEF;IACI;QACI,WAAW;IACf;IACA;QACI,cAAc;MAChB;MACA;QACE,aAAa;QACb,uBAAuB;MACzB;IACF;QACI,iBAAiB;IACrB;GACD;MACG,iBAAiB;GACpB;AACH","sourcesContent":[".comment-todo{\n    border-radius: 13px;\n    border: 2px solid #ebebeb;\n    overflow: hidden;\n}\n.post-views{\n    font-size: 12px;\n    color: #818181;\n}\n.post-icons{\n    height: 40px;\n    width: 40px;\n    margin: auto\n}\n.post-icons:hover{\n    border: 2px solid darkgray;\n    border-radius: 50%;\n    transform: scale(0.9);\n    transition: transform .1s ease-in-out;\n    cursor: pointer\n}\n.comment-name{\n    color: #050505;\n    font-size: 10px;\n}\n.comments-border{\n    border: 1px solid #c3c3c3;\n    padding: 10px 5px;\n    border-radius: 10px;\n    background-color: #f2f2f2;\n\n}\n.comments-img{\n    width: 43px;\n    border-radius: 100%;\n    border: 2px solid #000;\n}\n.taskdone{\n    font-size: 10px;\n     color: #818181;;\n}\n.fs-btn-accept{\n    font-size: 20px;\n    background-color: #009345!important;\n    border: 1px solid #ccc;\n    font-weight: 700;\n}\n.star-gold{\n    color: #fa921b;\n    font-size: 12px;\n   \n}\n.icon-green{\n    color: #3ab34a;\n    font-size: 15px;\n}\n.text-comment{\n \n    position: relative;\n    left: 162px;\n}\n.comment-text {\n    background-color: var(--bs-blue);\n    width: 240px;\n    color: #f2f2f2;\n    position: relative;\n    word-wrap: break-word; /* Break long words to prevent overflow */\n    overflow-wrap: break-word; /* Ensures text breaks to next line */\n    white-space: pre-wrap; /* Preserves whitespace and wraps text */\n    overflow: hidden; /* Hides any overflowing content */\n}\n.comment-text::before{\n    display: block;\n    clear: both;\n    content: \"\";\n    position: absolute;\n    bottom: -8px;\n    width: 0;\n    height: 0;\n    border-style: solid;\n    border-width: 12px;\n    -webkit-transform: rotate(-37deg);\n    -ms-transform: rotate(-37deg);\n    transform: rotate(317deg);\n    border-color: #3e353500 #9b969600 #f8f9fa00 var(--bs-blue);\n    right: -12px;\n}\n.comment-textRight{\n    background-color:  var(--bs-tertiary-bg);\n    width: 240px;\n    color: black;\n    overflow-wrap: break-word;\n}\n.todo-border{\n    border: 2px solid black;\n    border-radius: 0.25em;\n   font-size: small;\n}\n.todo-border:checked {\n    background-color: #009345;\n    border-color: #009345;\n}\n.todo-label{\n    color: #818181;\n}\n.video-post{\n    border-radius: 10px;\n}\n/* .comment-text-bottom{\n    position: absolute;\n    height: 0;\n    border-style: solid;\n    border-width: 12px;\n    border-color: #3e353500 #9b969600 #f8f9fa00 var(--bs-blue);\n    right: -12px;\n} */\n.codecolor{\n    background-color: #818181;\n    display: inline-block;\n    width: 30px;\n    height: 30px;\n    border-radius: 100%;\n    text-align: center;\n    line-height: 27px;\n    color: #fff;\n    margin-top: 4px;\n}\n.moving-aud{\n    position: relative;\n \n}\n.moving-aud audio{\n    width: 220px!important;\n}\n.custom-form-edit{\n    width: 170px;\n    padding: 10px;\n    margin: 5px;\n    box-sizing: border-box;\n    border: 1px solid #ccc;\n}\n.comment-text.comment1-text::before {\n    display: none;\n   }\n   .scrollableChat {\n    overflow-y: auto;\n    height: calc(65vh - 100px);\n}\n.comment-text1{\n    width: 240px;\n    /* color: #f2f2f2; */\n    position: relative;\n}\n.comment-textRight1{\n    width: 240px;\n    /* color: black; */\n    overflow-wrap: break-word;\n}\n.text-dark i{\n    font-weight: 900;\n}\n.scrollable-overflow{\n    overflow-x: hidden;\n}\n.absoluteposition{\n    position: absolute;\n    right: 150px;\n    bottom: -15px;\n}\n\n/* Modal overlay */\n.modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.8);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1000;\n  }\n  \n  /* Modal content */\n  .modal-comments .modal-content{\n    position: relative;\n    background: white;\n    padding: 20px;\n    width: 500px;\n    height: auto;\n    border-radius: 10px;\n    text-align: center;\n  }\n  \n  .close-button {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    background: transparent;\n    border: none;\n    font-size: 24px;\n    cursor: pointer;\n  }\n  \n  /* Enlarged image */\n  .enlarged-image {\n    max-width: fit-content;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    max-height: 80vh;\n  }\n  \n@media screen and (max-width:576px) {\n    .imagewidth-comments{\n        width: 100%;\n    }\n    .enlarged-image {\n        max-width: 89%;\n      }\n      .en-large{\n        display: flex;\n        justify-content: center;\n      }\n    .todos-home{\n        padding-left: 3px;\n    }\n   .gigclass{\n      padding-left: 5px;\n   }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
